import { sanitizeHtml } from '~/serverUtils/sanitizeHtml';

interface Props extends React.HTMLAttributes<HTMLElement> {
    tag?: keyof HTMLElementTagNameMap;
    html: string;
}

function SafeHTML({ html, tag: Tag = 'div', ...props }: Props) {
    return <Tag {...props} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />;
}

export default SafeHTML;
